import * as Blockly from 'blockly/core'
import { LuaGenerator, Order } from 'blockly/lua'
import {
  BlockDefinition,
  numberInput,
  numberOutput,
  statementBlock,
} from './common'
import { missionManager } from './mission'

export const SOUND_CATEGORY = 'SOUND'

export const soundDefaults: Partial<BlockDefinition> = {
  style: 'sound',
}

export const soundBlocks: Array<BlockDefinition> = [
  {
    opcode: 'sound_play',
    ...statementBlock,
    generator: () => 'script.Parent.Sound:Play()\n',
    message0: '%{BKY_B_PLAY_SOUND}',
  },
  {
    opcode: 'sound_volume',
    ...numberOutput,
    generator: () => ['script.Parent.Sound.Volume * 100', Order.MULTIPLICATIVE],
    message0: '%{BKY_B_VOLUME}',
  },
  {
    opcode: 'sound_changeVolumeBy',
    ...statementBlock,
    ...numberInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const v = generator.valueToCode(block, 'VAL', Order.MULTIPLICATIVE)
      return `script.Parent.Sound.Volume += ${v} / 100\n`
    },
    message0: '%{BKY_B_CHANGE_VOLUME_BY}',
  },
  {
    opcode: 'sound_setVolumeTo',
    ...statementBlock,
    ...numberInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const v = generator.valueToCode(block, 'VAL', Order.MULTIPLICATIVE)
      return `script.Parent.Sound.Volume = ${v} / 100\n`
    },
    message0: '%{BKY_B_SET_VOLUME_TO}',
  },
]

const soundToolbox = [
  {
    kind: 'block',
    type: 'sound_play',
  },
  {
    kind: 'block',
    type: 'sound_volume',
  },
  {
    kind: 'block',
    type: 'sound_changeVolumeBy',
    inputs: { VAL: { shadow: { type: 'math_number', fields: { NUM: -10 } } } },
  },
  {
    kind: 'block',
    type: 'sound_setVolumeTo',
    inputs: { VAL: { shadow: { type: 'math_number', fields: { NUM: 100 } } } },
  },
]

const soundToolboxDisabled = soundToolbox.map((block) => ({
  ...block,
  disabled: true,
}))

const soundFlyoutCallback = () =>
  missionManager.hasSound() ? soundToolbox : soundToolboxDisabled

export const registerSoundCallbacks = (workspace: Blockly.WorkspaceSvg) => {
  workspace.registerToolboxCategoryCallback(SOUND_CATEGORY, soundFlyoutCallback)
}
